/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:e27de3db-ed5a-40c1-bff2-18c52b41c2e7",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_B0sxWzKcd",
    "aws_user_pools_web_client_id": "2ut241gkts0tkvr39cjniu5eaa",
    "oauth": {
        "domain": "strteamamplifyapp92d506b5-92d506b5-dev.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://strategyteamtestapp.rme.amazon.dev/,http://localhost:3000/",
        "redirectSignOut": "https://strategyteamtestapp.rme.amazon.dev/,http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "strteamamplifyapp-storage-6e109dce3a8b3-dev",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
